import React from 'react';
import _ from 'lodash';
import './index.scss';
import { useTranslation } from 'react-i18next';
const BrowseTopDrugsAlphabet = () => {
  const { i18n, t } = useTranslation(); // get i18n and t from hook
  const alphabets = [...Array(26).keys()].map(i => String.fromCharCode(i + 65));
  return (
    <div className="alphabetMainSection">
      <div className="alphabetContainer">
        <div className="alphabetHeader">
          <h2>{t('Browse drugs A-Z')}</h2>
          <div className="viewAll">
            <a href={_.withLocale(i18n.language, `/browse-prescriptions`)}>
              {t('View all label')}
            </a>
          </div>
        </div>
        <div className="alphabet">
          {alphabets.map(alphabet => (
            <a
              href={_.withLocale(
                i18n.language,
                `/browse-prescriptions/${alphabet.toLowerCase()}`
              )}
              key={alphabet}
            >
              {alphabet}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrowseTopDrugsAlphabet;
